import { useState, useEffect } from 'react'
import { TextInput } from '@instructure/ui'

export const ValidatingTextInput = ({ value, onChange, ...props }) => {

  const [textValue, setTextValue] = useState('')
  const [validationMessage, setValidationMessage] = useState([])

  useEffect(() => {
    if(value && value !== '' && value !== textValue) {
      setTextValue(value)
    }
    // disabled on initial eslint-plugin-react-hooks configuration
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const validateField = (onChangeEvent) => {
    if (onChangeEvent.target.validationMessage !== '') {
      return [{ type: 'error', text: onChangeEvent.target.validationMessage }]
    }
    return []
  }

  const handleValidation = (e) => {
    e.target?.checkValidity()
  }

  const handleInvalid = (e) => {
    e.preventDefault()
    setValidationMessage(validateField(e))
    return false
  }

  const handleOnChange = (e) => {
    setTextValue(e.target.value)
    setValidationMessage(validateField(e))
    if(onChange) {
      onChange(e, e.target.value)
    }
  }

  return (
    <TextInput
      value={textValue}
      onBlur={handleValidation}
      onInvalid={handleInvalid}
      onChange={handleOnChange}
      messages={validationMessage}
      {...props}
    />
  )
}